const NAMESPACE = 'errors/';

export default {
  THROW_GLOBAL_ERROR: `${NAMESPACE}THROW_GLOBAL_ERROR`,
  DISMISS_GLOBAL_ERROR: `${NAMESPACE}DISMISS_GLOBAL_ERROR`,
};
